import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClassicReenrollmentTriggerSetsEvalExplanation = ({
  matchResult
}) => {
  const explanationCopy = (() => {
    switch (matchResult) {
      case 'VALID':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.VALID"
        });
      case 'INVALID_LIST':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_LIST"
        });
      case 'INVALID_FORM':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_FORM"
        });
      case 'INVALID_FORM_PAGE':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_FORM_PAGE"
        });
      case 'INVALID_PROPERTY_NAME':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_PROPERTY_NAME"
        });
      case 'INVALID_PROPERTY_VALUE':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_PROPERTY_VALUE"
        });
      case 'INVALID_LIST_CHANGE_STATUS':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_LIST_CHANGE_STATUS"
        });
      case 'INVALID_LIST_BULK_OBJECT_SEG_SOURCE':
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_LIST_BULK_OBJECT_SEG_SOURCE"
        });
      case 'INVALID_LIST_OBJECT_SEG_SOURCE':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.matchResult.INVALID_LIST_OBJECT_SEG_SOURCE"
        });
      default:
        {
          Raven.captureMessage('Unexpected ClassicReEnrollmentMatchResult', {
            extra: {
              matchResult
            }
          });
          return null;
        }
    }
  })();
  return /*#__PURE__*/_jsxs("div", {
    children: [matchResult === 'VALID' ? /*#__PURE__*/_jsx(SuccessIcon, {
      color: "do-not-use-oz",
      alignWithText: true
    }) : /*#__PURE__*/_jsx(RemoveIcon, {
      color: "do-not-use-candy-apple",
      alignWithText: true
    }), explanationCopy]
  });
};
export default ClassicReenrollmentTriggerSetsEvalExplanation;